// extracted by mini-css-extract-plugin
export default {"emptyMessage":"ListingListNotFound_emptyMessage__U14GM","subtitle":"ListingListNotFound_subtitle__QfZ2R"};